import { getFacturxApiBase } from "../suiteSession";
import type { Company } from "../types";

export function companyLogoUrl(company: Company): string {
  const stamp = company.updated_at || company.logo_path || String(company.id);
  return `${getFacturxApiBase()}/company-logo.php?company_id=${company.id}&kind=mark&v=${encodeURIComponent(stamp)}`;
}

export function companyLetterheadUrl(company: Company): string {
  const stamp = company.updated_at || company.letterhead_logo_path || String(company.id);
  return `${getFacturxApiBase()}/company-logo.php?company_id=${company.id}&kind=letterhead&v=${encodeURIComponent(stamp)}`;
}

export function companyInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
